
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organise-event",
      function () {
        return require("private-next-pages/organise-event.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/organise-event"])
      });
    }
  